const Content: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = (props) => {
    return (
        <div
            className={`p-5 md:px-32 md:py-10`.concat(" " + props.className || "")}
        >
            {props.children}
        </div>
    )
}

export default Content